import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { storageKey: String }

  connect() {
    this.storageKey = this.storageKeyValue || "communityHeroHidden"
    if (this.isHidden()) {
      this.element.classList.add("hidden")
    }
  }

  dismiss() {
    this.persistHidden()
    this.element.classList.add("hidden")
  }

  isHidden() {
    try {
      return window.localStorage.getItem(this.storageKey) === "true"
    } catch (error) {
      return false
    }
  }

  persistHidden() {
    try {
      window.localStorage.setItem(this.storageKey, "true")
    } catch (error) {
      // Ignore storage failures (private mode, disabled storage).
    }
  }
}
